import React from 'react';
import RadioGroupContext from './RadioGroupContext';

export type RadioGroupProps = {
  name: string;
  value: string | number | undefined;
  children: React.ReactNode;
  onChange: (value: string | number) => void;
};

const RadioGroup = ({ name, value, onChange, children }: RadioGroupProps) => {
  return (
    <RadioGroupContext.Provider value={{ name, value, onChange }}>
      {children}
    </RadioGroupContext.Provider>
  );
};
export default RadioGroup;
